import { NormilizedAssignedTags, Tag } from 'tags/models/tags';
import { AssignedTagToRSimDTO, AssignedTagToSimDTO } from 'tags/models/tagsApi.types';

export const mapTagsToOptions = (tags: Tag[]) => {
  return tags.map((tag) => ({
    ...tag,
    toAdd: false,
    toSave: false,
  }));
};

export const normilizeAssignedTagsToSim = (tags: AssignedTagToSimDTO[]) => {
  const normilzeTags: NormilizedAssignedTags = tags.reduce((tags, tag) => {
    return {
      ...tags,
      [tag.iccid]: {
        items: tag.tags,
        hasMore: tag.hasMore,
      },
    };
  }, {});

  return normilzeTags;
};

export const normilizeAssignedTagsToRSim = (tags: AssignedTagToRSimDTO[]) => {
  const normilzeTags: NormilizedAssignedTags = tags.reduce((tags, tag) => {
    return {
      ...tags,
      [tag.euicc]: {
        items: tag.tags,
        hasMore: tag.hasMore,
      },
    };
  }, {});

  return normilzeTags;
};
